import React from 'react';

import GenericPage from 'elements/genericPage';

function Devices() {
  return <GenericPage storageName="ingredients" tableTitle="Ингредиенты" />;
}

export default Devices;
